import type { SpaceStatus, UnlockRequestStatus } from "./__generated__/DoorUnlockPollingQuery.graphql";

export type DoorUnlockPhase = "waiting_for_open" | "waiting_for_close" | "closed" | "timed_out" | "error";

export type DoorUnlockMachineState = {
	phase: DoorUnlockPhase;
	hasObservedOpen: boolean;
	message?: string;
};

export type DoorUnlockSnapshot = {
	doorStatus: SpaceStatus;
	unlockStatus: UnlockRequestStatus;
	unlockedAt: string | null | undefined;
	error: string | null | undefined;
};

export const initialDoorUnlockState: DoorUnlockMachineState = {
	phase: "waiting_for_open",
	hasObservedOpen: false,
};

export function transitionDoorUnlock(state: DoorUnlockMachineState, snapshot: DoorUnlockSnapshot): DoorUnlockMachineState {
	const { doorStatus, unlockStatus, unlockedAt, error } = snapshot;

	// The physical state wins over the request status: an open door must always
	// lead to close-door instructions, even when the request timed out or failed.
	switch (doorStatus) {
		case "OPEN":
			return { phase: "waiting_for_close", hasObservedOpen: true };
		case "%future added value":
			return { phase: "error", hasObservedOpen: state.hasObservedOpen, message: "Unexpected door status" };
		case "CLOSED":
			break;
	}

	// A closed door completes the cycle only when we can prove it was opened by
	// this request, either now, in a previous poll, or before a page refresh.
	if (state.hasObservedOpen || unlockStatus === "UNLOCKED" || unlockedAt != null) {
		return { phase: "closed", hasObservedOpen: true };
	}

	switch (unlockStatus) {
		case "PENDING":
		case "EXECUTED":
			return { phase: "waiting_for_open", hasObservedOpen: false };
		case "TIMED_OUT":
			return { phase: "timed_out", hasObservedOpen: false, message: error ?? undefined };
		case "ERROR":
			return { phase: "error", hasObservedOpen: false, message: error ?? undefined };
		case "%future added value":
			return { phase: "error", hasObservedOpen: false, message: error ?? "Unexpected unlock status" };
	}
}
